// 单页首页静态展示数据 —— 题材均为虚构娱乐瓜，仅供页面观感与排版使用
export type FeedCard = {
  tag: string;
  tone: string;
  heat: number;
  comments: number;
  title: string;
  summary: string;
  cover: string;
};

export const featuredCards: FeedCard[] = [
  {
    tag: "今日热瓜",
    tone: "hot",
    heat: 96,
    comments: 4280,
    title: "程野深夜直播念错新品名，商务团队连夜改稿被撞见",
    summary: "一句话口误被弹幕整场刷屏，随后原定明日发布的物料悄悄下架重排。",
    cover: "https://readdy.ai/api/search-image?query=mysterious%20male%20celebrity%20silhouette%20backstage%20behind%20frosted%20glass%20dramatic%20warm%20amber%20spotlight%20against%20deep%20charcoal%20editorial%20background%20cinematic%20film%20grain%20moody%20gossip%20magazine%20cover%20aesthetic%20high%20contrast%20glamorous%20mystery%20lighting%20with%20elegant%20negative%20space&width=720&height=900&seq=featured-f1&orientation=portrait",
  },
  {
    tag: "首发",
    tone: "first",
    heat: 88,
    comments: 2190,
    title: "苏梨顾言迟同框拍摄路透，中间这段空档网友开扒",
    summary: "候场半小时两人保持礼貌距离，粉丝却把时间线镜头一格格对齐复盘。",
    cover: "https://readdy.ai/api/search-image?query=two%20silhouettes%20facing%20each%20other%20across%20a%20studio%20corridor%20golden%20afternoon%20backlight%20creating%20long%20shadows%20warm%20amber%20and%20rose%20tones%20on%20charcoal%20editorial%20backdrop%20cinematic%20grain%20moody%20gossip%20spread%20aesthetic%20unspoken%20tension%20elegant%20negative%20space&width=720&height=900&seq=featured-f2&orientation=portrait",
  },
  {
    tag: "实锤",
    tone: "proof",
    heat: 91,
    comments: 3540,
    title: "叶书白录音棚清唱片段流出，真假直播让弹幕吵翻",
    summary: "前后两个机位同一句歌词对不上，吃瓜群众连夜做波形对比图。",
    cover: "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20studio%20microphone%20with%20neon%20sound%20wave%20glow%20in%20warm%20red%20and%20amber%20lighting%20against%20dark%20charcoal%20recording%20booth%20editorial%20background%20cinematic%20film%20grain%20moody%20music%20gossip%20cover%20aesthetic%20high%20contrast%20mysterious%20atmosphere%20dramatic%20negative%20space&width=720&height=900&seq=featured-f3&orientation=portrait",
  },
  {
    tag: "速递",
    tone: "speed",
    heat: 84,
    comments: 1860,
    title: "陈墨红毯造型翻车复盘，同一套被扒三年前的旧图",
    summary: "定妆照和现场原图落差有点大，造型团队深夜发长文认领。",
    cover: "https://readdy.ai/api/search-image?query=elegant%20female%20celebrity%20silhouette%20on%20a%20glossy%20red%20carpet%20warm%20spotlight%20halo%20soft%20reflection%20on%20dark%20charcoal%20editorial%20stage%20background%20cinematic%20film%20grain%20moody%20fashion%20gossip%20cover%20aesthetic%20high%20contrast%20glamorous%20dramatic%20lighting%20elegant%20negative%20space&width=720&height=900&seq=featured-f4&orientation=portrait",
  },
  {
    tag: "独家",
    tone: "exclusive",
    heat: 82,
    comments: 1450,
    title: "林知夏商务路透一人两版报价单，中介说法当场对不上",
    summary: "同一档期被爆出两份不同口径的报价，圈内几个群聊直接炸开。",
    cover: "https://readdy.ai/api/search-image?query=document%20folder%20and%20pen%20lying%20on%20a%20desk%20lit%20by%20a%20single%20warm%20amber%20desk%20lamp%20against%20dark%20charcoal%20office%20background%20cinematic%20film%20grain%20moody%20scandal%20dossier%20cover%20aesthetic%20high%20contrast%20mysterious%20atmosphere%20elegant%20negative%20space&width=720&height=900&seq=featured-f5&orientation=portrait",
  },
];

export type ExpressRow = {
  tag: string;
  title: string;
  summary: string;
  time: string;
  views: string;
  comments: number;
  tone: string;
};

export const expressList: ExpressRow[] = [
  {
    tag: "首发",
    title: "夏可晴新剧杀青宴路透，席间这段互动被拍下",
    summary: "散场时她主动去敬了一圈酒，其中一桌明显停顿了几秒才起身。",
    time: "14:02",
    views: "38.6w",
    comments: 620,
    tone: "first",
  },
  {
    tag: "速递",
    title: "顾言迟新商务物料连夜返工，官方措辞悄悄改了一处",
    summary: "发布会通稿里那句原话被删掉，取而代之的是更稳妥的公关话术。",
    time: "12:47",
    views: "29.1w",
    comments: 480,
    tone: "speed",
  },
  {
    tag: "独家",
    title: "某综艺花絮流出，导师评价和正片完全两种态度",
    summary: "正片里是夸，未播花絮里却是另一句评价，反差被观众逐帧点名。",
    time: "11:20",
    views: "45.8w",
    comments: 910,
    tone: "exclusive",
  },
  {
    tag: "实锤",
    title: "程野工作室声明里的时间点，被扒出和行程对不上",
    summary: "声明说人在休假，可网友手里的机场路透写着同一天，留言直接翻车。",
    time: "09:58",
    views: "52.3w",
    comments: 1340,
    tone: "proof",
  },
  {
    tag: "热瓜",
    title: "苏梨粉丝应援海报被同款撞车，两边团队都在等说法",
    summary: "两张海报构图几乎一模一样，是谁抄谁成了今晚票圈最大悬念。",
    time: "08:31",
    views: "33.4w",
    comments: 760,
    tone: "hot",
  },
];

export type TimelineItem = {
  time: string;
  tag: string;
  title: string;
  comments: number;
};

export const todayTimeline: TimelineItem[] = [
  { time: "07:30", tag: "速递", title: "晨间首更：昨日三条热瓜已有两方给出回应", comments: 210 },
  { time: "09:12", tag: "新瓜", title: "商务路透曝光，中介口径不一引发讨论", comments: 1340 },
  { time: "11:40", tag: "花絮", title: "综艺未播花絮与正片评价反差，逐帧热议", comments: 910 },
  { time: "13:05", tag: "实锤", title: "红毯旧图对比帖发出，三小时内近万人点赞", comments: 1860 },
  { time: "15:22", tag: "首发", title: "深夜直播片段重新剪辑，粉丝连夜复盘时间线", comments: 2190 },
  { time: "17:48", tag: "速递", title: "两版商务口径被晒出，群聊截图开始外传", comments: 1450 },
  { time: "20:03", tag: "热瓜", title: "话题榜冲进前三，实时讨论人数突破两万", comments: 3540 },
  { time: "22:15", tag: "首发", title: "晚间加更：新一批同框图路透排队放出", comments: 4280 },
];

export type Thread = {
  title: string;
  meta: string;
  people: string;
  votes: number;
  mood: string;
};

export const hotThreads: Thread[] = [
  {
    title: "程野这次直播口误，是失误还是早就准备好的剧本？",
    meta: "发起人：吃瓜老K · 已热议 2 小时",
    people: "68 人正在聊",
    votes: 1560,
    mood: "hot",
  },
  {
    title: "叶书白清唱对比波形图，真翻车还是剪辑背锅？",
    meta: "发起人：录音棚小记 · 已热议 3 小时",
    people: "52 人正在聊",
    votes: 980,
    mood: "proof",
  },
  {
    title: "两版同款海报，你觉得更偏向谁抄谁？",
    meta: "发起人：设计圈路人 · 已热议 1 小时",
    people: "41 人正在聊",
    votes: 720,
    mood: "proof",
  },
  {
    title: "声明里的时间点和路透对不上，这次你站哪边？",
    meta: "发起人：追更到天明 · 已热议 4 小时",
    people: "37 人正在聊",
    votes: 660,
    mood: "hot",
  },
];

export type RankItem = {
  rank: number;
  text: string;
  heat: number;
};

export const hotRank: RankItem[] = [
  { rank: 1, text: "苏梨顾言迟同框图，空档期到底在聊什么", heat: 4280 },
  { rank: 2, text: "程野直播口误全记录，从翻车到改稿全程", heat: 3540 },
  { rank: 3, text: "陈墨红毯旧图对比，同款造型三年前就有", heat: 2190 },
  { rank: 4, text: "夏可晴杀青宴路透，敬酒那一桌停顿太久", heat: 1860 },
  { rank: 5, text: "声明时间点与行程冲突，复盘贴热度飙升", heat: 1450 },
];

export type CircleItem = {
  icon: string;
  name: string;
  desc: string;
  count: string;
};

export const circles: CircleItem[] = [
  { icon: "ri-vidicon-line", name: "综艺圈", desc: "花絮 / 录制现场 / 导师内幕", count: "今日 6 更" },
  { icon: "ri-camera-line", name: "影剧圈", desc: "路透 / 杀青宴 / 番位话题", count: "今日 5 更" },
  { icon: "ri-radio-2-fill", name: "直播圈", desc: "连麦 / 翻车 / 回放复盘", count: "今日 8 更" },
  { icon: "ri-store-line", name: "商务瓜", desc: "报价 / 物料 / 代言风向", count: "今日 4 更" },
  { icon: "ri-team-fill", name: "粉圈前线", desc: "应援 / 时间线 / 粉丝复盘", count: "今日 7 更" },
  { icon: "ri-shield-check-line", name: "辟谣站", desc: "反转 / 声明 / 实锤认证", count: "今日 3 更" },
];

export type GalleryItem = {
  cover: string;
  caption: string;
  note: string;
  ratio: string;
};

export const gallery: GalleryItem[] = [
  {
    ratio: "tall",
    caption: "同款打卡照",
    note: "把两张同框图并排放大，构图差一眼就能看出",
    cover: "https://readdy.ai/api/search-image?query=side%20by%20side%20comparison%20of%20two%20similar%20poster%20compositions%20arranged%20on%20a%20dark%20charcoal%20wall%20lit%20by%20warm%20amber%20gallery%20lights%20cinematic%20film%20grain%20editorial%20collage%20investigation%20aesthetic%20high%20contrast%20moody%20forensic%20study%20elegant%20negative%20space&width=760&height=980&seq=gallery-g1&orientation=portrait",
  },
  {
    ratio: "wide",
    caption: "红毯旧图 vs 现场",
    note: "同一套造型，隔了三年再看落差有多少",
    cover: "https://readdy.ai/api/search-image?query=glossy%20red%20carpet%20scene%20under%20warm%20golden%20spotlights%20with%20soft%20motion%20and%20crowd%20silhouettes%20against%20dark%20charcoal%20background%20cinematic%20film%20grain%20editorial%20comparison%20aesthetic%20high%20contrast%20glamorous%20dramatic%20lighting%20elegant%20negative%20space&width=980&height=700&seq=gallery-g2&orientation=landscape",
  },
  {
    ratio: "tall",
    caption: "时间线拼图",
    note: "正片夸、花絮损，把两段评价拉到同一屏",
    cover: "https://readdy.ai/api/search-image?query=collage%20of%20film%20clapperboard%20frames%20and%20quote%20bubbles%20pinned%20on%20a%20dark%20charcoal%20studio%20wall%20lit%20by%20warm%20amber%20light%20cinematic%20film%20grain%20editorial%20montage%20analysis%20aesthetic%20high%20contrast%20moody%20forensic%20layout%20elegant%20negative%20space&width=760&height=980&seq=gallery-g3&orientation=portrait",
  },
  {
    ratio: "wide",
    caption: "波形对比",
    note: "同一句歌词的两条波形，粉丝连夜做了标注",
    cover: "https://readdy.ai/api/search-image?query=overlapping%20sound%20wave%20forms%20projected%20in%20warm%20red%20and%20amber%20neon%20against%20dark%20charcoal%20background%20cinematic%20film%20grain%20editorial%20audio%20forensic%20aesthetic%20high%20contrast%20technical%20moody%20lighting%20elegant%20negative%20space&width=980&height=700&seq=gallery-g4&orientation=landscape",
  },
];

export const tickerItems: string[] = [
  "13:26 · 程野直播口误事件又出新片段",
  "13:02 · 苏梨同框图讨论人数突破两万",
  "12:47 · 顾言迟新物料连夜返工被证实",
  "12:15 · 某商务路透两版口径说法互冲",
  "11:40 · 综艺未播花絮对比帖正在刷屏",
  "11:02 · 陈墨红毯旧图复盘新增两张对照",
];